__turbopack_context__.v({
  "trigger": "UserMenu-module__wX73Na__trigger",
});
